import { IonContent } from '@ionic/react';
import React from 'react';

import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { useOnboarding } from '@/pages/Onboarding/context';
import { canLogEvents } from '@/utils/canLogEvents';

import {
  Card,
  LogoLarge,
  LogoMedium,
  LogoSmall,
  QuoteImg,
  Text,
} from './Social.styles.ts';

export const OnboardingScreenSocial: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Social',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const handleNextStep = (): void => {
    wizard.nextStep();
  };

  const handleBackStep = () => {
    wizard.goToStep('name');
  };

  return (
    <OnboardingPage className="onboarding-loneliness">
      <OnboardingNavigation onBack={handleBackStep} />

      <OnboardingTitle className="title">They talk about us!</OnboardingTitle>

      <IonContent>
        <Card>
          <Text>
            ...Dialogue has attracted 1.04 million early adopters with 150,000
            monthly active users...
          </Text>
          <QuoteImg src={'/assets/quote-image.png'} alt="quote" />
          <LogoLarge src={'/assets/yahoo-logov2.png'} alt="logo" />
        </Card>
        <Card>
          <Text>
            ...Dialogue delivers an experience that feels genuinely personal.
          </Text>
          <QuoteImg src={'/assets/quote-image.png'} alt="quote" />
          <LogoSmall src={'/assets/usa-today-logo.png'} alt="logo" />
        </Card>
        <Card>
          <Text>
            ...Dialogue is a virtual BFF who’s always ready to chat...
          </Text>
          <QuoteImg src={'/assets/quote-image.png'} alt="quote" />
          <LogoMedium src={'/assets/tech-9ullion-logo.png'} alt="logo" />
        </Card>
      </IonContent>

      <OnboardingFooter onContinue={handleNextStep} />
    </OnboardingPage>
  );
};
